import { assign } from 'lodash';
import axios from './axios';
// Обёртка для ajax-функций
var apiAdapter = (function (self) {
  'use strict';
  self.url = ""; // адрес по умолчанию
  self.context = {};
  self.execution = ""; // защитный код
  self._csrf = ""; // защитный код
  self.srpConfig = {};
  // триггер блокировки
  self.isBocked = false;
  // контроль пришёл ли ответ от сервера
  self.isAnswer = true;
  // для доступа к языковым константам из компонентов
  self.getTranslation = function (a, b) {
    return (com.rooxteam.i18n.getTranslation(a, b, self.context.moduleId));
  };
  // текущий язык
  self.getLanguage = function (a, b) {
    return com.rooxteam.i18n.getLanguage();
  };
  self.sendSerializer = function (data) {
    if (typeof data.execution != 'undefined') {
      self.execution = data.execution;
    }
    if (typeof data._csrf !== 'undefined') {
      self._csrf = data._csrf;
    }
    if (typeof data.serverUrl !== 'undefined') {
      self.url = data.serverUrl;
    }
    var component = "";
    var params = {};
    params["isCaptcha"] = false;
    params["isSRP"] = self.context.isSRP; // ! виджет всегда работает в режиме srp (если иное не указанно в настройках)
    params["recaptchaSiteKey"] = false;
    params["isBlocked"] = false;
    params["blockedFor"] = null;
    params["srp_challenge"] = {};
    params["srp_step"] = 1;
    params["context"] = {};
    params["msisdn"] = null;
    params["nextOtpCodePeriod"] = null;
    params["otpCodeNumber"] = null;
    params["isToo_many_wrong_code"] = false;
    // Ошибки
    if (typeof data !== 'undefined' && typeof data.form !== 'undefined' && typeof data.form.errors !== 'undefined' && data.form.errors.length > 0) {
      var errorStr = "",
        el = "";
      for (var i in data.form.errors) {
        if (data.form.errors.hasOwnProperty(i)) {
          if (data.form.errors.hasOwnProperty(i)) {
            el = data.form.errors[i];
            var err_s = self.getTranslation(el.message, "text", self.context.moduleId) + "<br>";
            // сколько попыток ввода ОТП кода осталось
            // если есть строка с кол-вом попыток и otpCodeAvailableAttempts существует, заменем часть строки
            if (typeof data.view !== 'undefined' && typeof data.view.otpCodeAvailableAttempts !== 'undefined' && (err_s.indexOf('%available_attempts%') + 1)) {
              var resAttempts = Util.remainingAttempts(data.view.otpCodeAvailableAttempts);
              errorStr += err_s.replace('%available_attempts%', resAttempts);
            } else if (el.message == 'too_many_wrong_code' && typeof data.view !== 'undefined' && typeof data.view.nextOtpCodePeriod !== 'undefined') {
              params["isToo_many_wrong_code"] = true;
            } else {
              errorStr += err_s;
            }
          }
        }
      } // end for
      params["errors_text"] = errorStr;
      params["otpCodeAvailableAttempts"] = data.view.otpCodeAvailableAttempts;
    }
    // Номер телефона
    if (typeof data.view !== 'undefined' && typeof data.view.msisdn !== 'undefined') {
      params["msisdn"] = data.view.msisdn;
    }
    // Вряем в секундах до отправки следующего OPT кода
    if (typeof data.view !== 'undefined' && typeof data.view.nextOtpCodePeriod !== 'undefined') {
      params["nextOtpCodePeriod"] = data.view.nextOtpCodePeriod;
    }
    // Номер попытки входа по OTP
    if (typeof data.view !== 'undefined' && typeof data.view.otpCodeNumber !== 'undefined') {
      params["otpCodeNumber"] = data.view.otpCodeNumber;
    }
    if (typeof data.view !== 'undefined' && typeof data.view.isBlocked !== 'undefined' && data.view.isBlocked) {
      params["isBlocked"] = true;
      self.isBocked = true;
      // блокировка с обратным отсчётом
      if (typeof data.view !== 'undefined' && typeof data.view.blockedFor !== 'undefined') {
        params["blockedFor"] = data.view.blockedFor;
        // на случай блокировки в форме OTP
        var er_blName = "too_many_wrong_code_un";
        if (params["isToo_many_wrong_code"]) {
          er_blName = "too_many_wrong_code";
        }
        var blockingTimeStr = self.getTranslation(er_blName, "text", self.context.moduleId);
        // получаем оставшиеся время до разблокировки
        var resTime = Util.remainingTime(((new Date()).getTime() + params["blockedFor"]), self.getLanguage(), " ");
        // заменяем время в шаблоне
        blockingTimeStr = blockingTimeStr.replace('%time%', resTime);
        params["errors_text"] = blockingTimeStr;
      }
    }
    // форма логина
    if (data.step == "auth_form" || data.step == "captcha_auth_form") {
      component = "login";
      if (data.step == "captcha_auth_form") {
        params["isCaptcha"] = true;
        // уникальный id captcha при каждом рендеринге (fix: ReCAPTCHA placeholder element must be empty)
        const randomBuffer = new Uint32Array(1);
        window.crypto.getRandomValues(randomBuffer);
        let randomNumber = randomBuffer[0] / (0xffffffff + 1);
        let min = Math.ceil(10000000);
        let max = Math.floor(1);
        params["captchaTempId"] = "g-recaptcha-id" + (Math.floor(randomNumber * (max - min + 1)) + min);
        if (typeof data.view != 'undefined' && data.view.recaptchaSiteKey != 'undefined') {
          params["recaptchaSiteKey"] = data.view.recaptchaSiteKey;
        }
      }
      // авторизация по протаколу srp
    } else if (data.step == "srp_auth" || data.step == "srp_challenge") {
      component = "login";
      // включение режима srp
      params["isSRP"] = true;
      // переключение на второй шаг
      if (data.step == "srp_challenge") {
        params["srp_step"] = 2;
      }
      if (typeof data.view != 'undefined' && data.view.srpChallenge != 'undefined') {
        params["srp_challenge"] = data.view.srpChallenge;
      }
      // форма отп
    } else if (data.step == "enter_otp_form") {
      component = "otp";
      // редирект
    } else if (data.step == "redirect") {
      window.location.href = data.location;
    }
    return {
      "component": component,
      "params": params,
      "context": data.context
    }
  };
  self.send = function (dataIn, srpMode, callback, evenId) {
    if (self.old_execution != self.execution) {
      // если включён режим srp, преключаем метод отправки данных
      if (srpMode) {
        // делаем запрос на сервер и получем ответ
        self.sendSRP(dataIn, callback, evenId);
      } else {
        // делаем запрос на сервер и получем ответ
        self.sendDef(dataIn, callback, evenId);
      }
    }
  };
  // метод получения данных с сервера
  self.sendDef = function (dataIn, callback, evenId) {
    if (typeof evenId === 'undefined') {
      evenId = 'next';
    }
    assign(dataIn, {
      "execution": self.execution,
      "_eventId": evenId,
      "_csrf": self._csrf
    });
    // проверка получен ли ответ от сервера
    if (self.isAnswer) {
      // ответ ещё не получен
      self.isAnswer = false;
      return axios({
        method: 'post',
        url: self.url,
        data: self.params(dataIn),
      }).then(
        data => {
          // ответ получен
          self.isAnswer = true;
          // меняем формат входящих данных
          data = self.sendSerializer(data);
          callback(data);
        },
        e => {
          // ответ получен
          self.isAnswer = true;
          if (/Authentication session expired/.test(e.responseText)) {
            callback({
              "component": "http_error",
              "params": {
                "text": "Authentication session expired",
                "code": 10
              }
            });
          } else {
            callback({
              "component": "http_error",
              "params": {
                "text": e.statusText,
                "code": e.status
              }
            });
          }
        }
      );
    }
  };
  self.sendSRP = function (dataIn, callback, evenId) {
    if (typeof evenId === 'undefined') {
      evenId = 'next';
    }
    // SRP Шаг 1
    var srpClient = null;
    try {
      srpClient = new SRP6JavascriptClientSessionSHA256();
      srpClient.step1(dataIn.username, dataIn.password);
    } catch (e) {
      //console.log(e.name)
    }
    var sendData = {
      "username": dataIn.username,
      "m_info": dataIn.m_info,
      "password": 'f',
      "execution": self.execution,
      "_eventId": evenId
      // "_csrf": self._csrf
    };
    // если установленна каптча, отправлеем её временный код
    if (typeof dataIn["gRecaptchaResponse"] != 'undefined' && dataIn["gRecaptchaResponse"] != "") {
      sendData["gRecaptchaResponse"] = dataIn["gRecaptchaResponse"];
    }
    // проверка получен ли ответ от сервера
    if (self.isAnswer) {
      // ответ ещё не получен
      self.isAnswer = false;
      return axios({
        method: 'post',
        url: self.url,
        data: self.params(sendData),
      }).then(
        data => {
          // ответ получен
          self.isAnswer = true;
          // защита от повторной отправки execution
          if (self.execution != data.execution) {
            if (typeof data.execution != 'undefined') {
              self.execution = data.execution;
            }
            if (typeof data._csrf !== 'undefined') {
              self._csrf = data._csrf;
            }
            if (typeof data.serverUrl !== 'undefined') {
              self.url = data.serverUrl;
            }
            if (typeof data.view !== 'undefined' && typeof data.view.srpChallenge !== 'undefined') {
              var salt = data.view.srpChallenge.salt;
              var b = data.view.srpChallenge.b;
              var credentials = { "A": "", "M1": "" };
              // SRP Шаг 2
              try {
                credentials = srpClient.step2(salt, b);
              } catch (e) {
                //console.log(e.name)
              }
              // проверка получен ли ответ от сервера
              if (self.isAnswer) {
                // ответ ещё не получен
                self.isAnswer = false;
                axios({
                  method: 'post',
                  url: self.url,
                  data: self.params({
                    "A": credentials.A,
                    "M1": credentials.M1,
                    "execution": self.execution,
                    "_eventId": evenId
                    // "_csrf": self._csrf
                  }),
                }).then(
                  data => {
                    // ответ получен
                    self.isAnswer = true;
                    if (typeof data.m2 == 'undefined') data["m2"] = "12345ad";
                    try {
                      if (srpClient.step3(data.m2)) {
                        //console.log('Auth success!');
                      } else {
                        //console.log('Illegal m2!');
                      }
                    } catch (e) {
                      //console.log(e.name)
                    } // end i
                    // получет m2 b
                    // меняем формат входящих данных
                    data = self.sendSerializer(data);
                    callback(data);
                  },
                  e => {
                    // ответ полчен
                    self.isAnswer = true;
                    if (/Authentication session expired/.test(e.responseText)) {
                      callback({
                        "component": "http_error",
                        "params": {
                          "text": "Authentication session expired",
                          "code": 10
                        }
                      });
                    } else {
                      callback({
                        "component": "http_error",
                        "params": {
                          "text": e.statusText,
                          "code": e.status
                        }
                      });
                    }
                  }
                );
              }
            } else {
              // меняем формат входящих данных
              data = self.sendSerializer(data);
              callback(data);
            }
          }
        },
        e => {
          // ответ получен
          self.isAnswer = true;
          if (/Authentication session expired/.test(e.responseText)) {
            callback({
              "component": "http_error",
              "params": {
                "text": "Authentication session expired",
                "code": 10
              }
            });
          } else {
            callback({
              "component": "http_error",
              "params": {
                "text": e.statusText,
                "code": e.status
              }
            });
          }
        }
      );
    }
  };
  // установка конфига srp
  self.setSRPConfig = function (conf) {
    if (typeof conf == 'undefined') conf = {};
    self.srpConfig["n"] = (typeof conf["n"] != 'undefined') ? conf["n"] : "11144252439149533417835749556168991736939157778924947037200268358613863350040339017097790259154750906072491181606044774215413467851989724116331597513345603";
    self.srpConfig["k"] = (typeof conf["k"] != 'undefined') ? conf["k"] : "b7867f1299da8cc24ab93e08986ebc4d6a478ad0"; // sha1(n*g)
    self.srpConfig["g"] = (typeof conf["g"] != 'undefined') ? conf["g"] : 2;
    self.srpConfig["h"] = (typeof conf["h"] != 'undefined') ? conf["h"] : "SHA-1";
    self.srpConfig["salt_bytes"] = (typeof conf["salt_bytes"] != 'undefined') ? parseInt(conf["salt_bytes"]) : 16;
  };
  self.sendForm = function (dataIn, callback, evenId) {
    if (typeof evenId === 'undefined') {
      evenId = 'next';
    }
    dataIn["execution"] = self.execution;
    dataIn["_eventId"] = evenId;
    // dataIn["_csrf"] = self._csrf;
    // проверка получен ли ответ от сервера (защита от повторного нажатия на кнопку отправки)
    if (self.isAnswer) {
      // ответ ещё не получен
      self.isAnswer = false;
      return axios({
        method: 'post',
        url: self.url,
        data: self.params(dataIn),
      }).then(
        data => {
          // ответ получен
          self.isAnswer = true;
          // меняем формат входящих данных
          data = self.sendSerializer(data);
          callback(data);
        },
        e => {
          // ответ получен
          self.isAnswer = true;
          if (/Authentication session expired/.test(e.responseText)) {
            callback({
              "component": "http_error",
              "params": {
                "text": "Authentication session expired",
                "code": 10
              }
            });
          } else {
            callback({
              "component": "http_error",
              "params": {
                "text": e.statusText,
                "code": e.status
              }
            });
          }
        }
      );
    }
  };
  self.params = function (_) {
    return Object.keys(_).map(k =>
      encodeURIComponent(k) + '=' + encodeURIComponent(_[k])).join('&');
  };
  return self;
})({});
window.apiAdapter = apiAdapter;
